import { MapPin } from "lucide-react";

export function LocationMap({ location, compact = false }) {
  if (!location) return <span className="text-slate-500 text-sm">Sem localização</span>;
  const steps = [
    { label: "Almoxarifado", value: location.almoxarifado },
    { label: "Corredor", value: location.corredor },
    { label: "Estante", value: location.estante },
    { label: "Prateleira", value: location.prateleira },
    { label: "Caixa/Posição", value: location.caixa },
  ].filter((s) => s.value);

  return (
    <div data-testid="part-location-visual-map" className={`flex flex-wrap items-stretch gap-2 ${compact ? "" : ""}`}>
      {steps.map((s, i) => (
        <div key={i} className="flex items-stretch">
          <div className="rounded-lg border border-sky-800/60 bg-sky-950/40 px-3 py-2 min-w-[92px]">
            <div className="text-[10px] uppercase tracking-widest text-sky-400/80 font-mono flex items-center gap-1">
              {i === 0 && <MapPin className="h-3 w-3" />} {s.label}
            </div>
            <div className="text-sm font-semibold text-slate-100 font-mono">{s.value}</div>
          </div>
          {i < steps.length - 1 && (
            <div className="flex items-center px-0.5 text-sky-600">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
